interface GatedSectionProps {
    title: string;
    children: React.ReactNode;
    onUpgrade: () => void;
}

export function GatedSection({ title, children, onUpgrade }: GatedSectionProps) {
    return (
        <div className="relative rounded-xl overflow-hidden">
            {/* Blurred content teaser */}
            <div className="blur-sm pointer-events-none select-none opacity-60" aria-hidden="true">
                {children}
            </div>

            {/* Overlay with unlock CTA */}
            <div className="absolute inset-0 flex items-center justify-center bg-surface-800/50 backdrop-blur-[1px] rounded-xl">
                <div className="text-center p-8 max-w-sm">
                    <div className="mx-auto w-12 h-12 rounded-full bg-quantum-500/10 flex items-center justify-center mb-4">
                        <svg className="w-6 h-6 text-quantum-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-text-primary mb-2">
                        Unlock Full {title}
                    </h3>
                    <p className="text-body-sm text-text-secondary mb-5">
                        Get detailed breakdowns, time-series data, and export capabilities with a full TotalView engagement.
                    </p>
                    <button
                        onClick={onUpgrade}
                        className="btn-primary px-6 py-2.5 text-body-sm font-medium"
                    >
                        Request Full Access
                    </button>
                </div>
            </div>
        </div>
    );
}
